var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.296734 0.292893C0.69238 -0.0976311 1.33385 -0.0976311 1.72949 0.292893L7.62908 6.11612C8.12364 6.60427 8.12364 7.39573 7.62908 7.88388L1.72949 13.7071C1.33385 14.0976 0.69238 14.0976 0.296734 13.7071C-0.0989114 13.3166 -0.0989114 12.6834 0.296734 12.2929L5.65904 7L0.296734 1.70711C-0.0989114 1.31658 -0.0989114 0.683417 0.296734 0.292893Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.5465c6f75e4c3bd320748634416a0e71.svg";
export { ForwardRef as ReactComponent };